import uploadProcurementFile from '../../../Services/uploadProcurementFile'

export default (acceptedFiles) => async (dispatch) => {

  dispatch(uploadProcurementFile(acceptedFiles))

}
